<template>
  <div class="sandbox">
    <vue-headful title="ALICE | Sandbox"></vue-headful>
    <div>
      <div>
        <input type="checkbox" v-model="funnelResult" /> Funnel Result
      </div>
      <div v-if="funnelResult">
        <funnel-result></funnel-result>
      </div>
    </div>
    <div>
      <div><input type="checkbox" v-model="gsapTest" /> Test GSAP</div>
      <button @click="reAnimate">Re-animate</button>
      <transition v-on:after-enter="animateIt">
        <div v-if="gsapTest">
          <div class="progress-wrapper">
            <div class="p-bar" id="bar-0">&nbsp;</div>
            <div class="p-bar" :id="`bar-${n}`" v-for="n in levelCount" :key="'bar'+n"/>
            <div class="progress-box" :id="`box-${n}`"
                v-for="n in progressCount" :key="'progress'+n"/>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import { TimelineMax } from 'gsap';
import FunnelResult from '../v1/Benchmark/FunnelResult.vue';

export default {
  name: 'Sandbox',
  components: {
    FunnelResult,
  },
  props: {},
  data() {
    return {
      funnelResult: false,
      gsapTest: false,
      levelCount: 3,
      progressCount: 100,
      stepCount: [50, 30, 10],
      barVerticalDistance: 40,
    };
  },
  mounted() {
    setTimeout(() => {
      this.animateIt();
    }, 1000);
  },
  methods: {
    reAnimate() {
      this.gsapTest = false;
      setTimeout(() => {
        this.gsapTest = true;
        this.animateIt();
      }, 300);
    },
    animateIt() {
      // console.log('UMM');
      const timeline = new TimelineMax();
      let currentPointer = 1;
      for (let i = 1; i <= this.levelCount; i += 1) {
        const y = this.barVerticalDistance * i;
        const bars = [];
        const currentStepCount = this.stepCount[i - 1];
        for (let j = i; j <= this.levelCount; j += 1) {
          bars.push(`#bar-${j}`);
        }
        timeline.to(bars, { y });
        const boxes = [];
        for (let k = currentPointer; k <= currentStepCount + currentPointer; k += 1) {
          const box = document.getElementById(`box-${k}`);
          boxes.push(box);
        }
        timeline.staggerTo(boxes, 0.1, {
          y,
          backgroundColor: '#44ada2',
        }, 0.05);
        // PT2
        const boxes2 = [];
        for (let k = currentStepCount + currentPointer + 1; k <= this.progressCount; k += 1) {
          const box = document.getElementById(`box-${k}`);
          boxes2.push(box);
        }
        timeline.staggerTo(boxes2, 0.1, {
          y,
          backgroundColor: '#888',
        }, 0.05);
        currentPointer += currentStepCount;
        // console.log(currentPointer);
      }
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
  .sandbox {
    .my-box {
      width: 200px;
      height: 200px;
      background-color: green;
    }
    .progress-wrapper {
      width: 100%;
      display: flex;
      position: relative;
      #bar-0 {
        background-color: #0aa7ef;
        //red #e16768
      }
      .p-bar {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        height: 40px;
        background-color: #ddd;
      }
      .progress-box {
        flex: 1 1 auto;
        display: inline-block;
        background-color: #888;
        text-align: center;
        /*border: 1px solid #ddd;*/
        height: 40px;
      }
    }
  }
</style>
